<password>
  <div class="password-title">パスワード設定</div>
  <!-- 電話番号の入力 -->
  <div if="{ !state.isNext && !state.isSet }" class="clearPassword">
    <p>パスワードの設定を行います。
      あなたの電話番号を入力して、「次へ」のボタンを押してください。</p>
    <div class="form-group">
      <label class="form-label" for="phone">電話番号</label>
      <input class="form-control" type="tel" id="phone" name="phone" onchange="{ handleChange('phone') }" required>
    </div>
    <button id="btn-next" class="btn" onclick="{ onClearClick }">次へ</button>
    <div class="link-group">
      <a class="back-page-txt" href="#{props.shopId }"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
    </div>
  </div>
  <!-- 電話番号の承認 -->
  <div if="{ state.isNext }" class="clearPasswordNext">
    <p>電話番号の承認を行います。</p>
    <p>{ state.formatPhone(state.phone) } から <a href="tel:{ getPhoneNumber() }">{ getPhoneNumber() }</a>に電話をしてください。</p>
    <p>続いて、2分以内に、「次へ」のボタンを押してください。</p>

    <div id="error-msg">
      { props.errorMsg }
    </div>
    <button id="btn-next" class="btn" onclick="{ onClearNextClick }">次へ</button>
    <div class="link-group">
      <a class="back-page-txt" onclick="{ onChangePage }"><i class="fas fa-angle-double-left"></i>電話番号の入力へ戻る</a>
    </div>
  </div>
  <div if="{ state.isSet }" class="clearPassword">
    <p>パスワードの登録を行います。
      パスワードを入力して、「保存」のボタンを押してください。</p>
    <div class="form-group">
      <label class="form-label" for="password">パスワード</label>
      <input class="form-control" type="password" id="password" name="password" onchange="{ handleChange('password') }"
        required>
    </div>
    <div id="error-msg">
      { state.errorMsg }
    </div>
    <button id="btn-save" class="btn" onclick="{ onSetClick }">保存</button>
    <div class="link-group">
      <a class="back-page-txt" href="#{props.shopId }"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
    </div>
  </div>
  <script>
    import { removePhoneHyphen, formatPhone, matchPhoneStart } from '@/common/utils/strings';
    export default {
      state: {
        formatPhone,
        phone: '',
        password: '',
        isNext: false,
        isSet: false,
      },

      onBeforeMount() {
        this.state.isNext = false;
        this.state.phone = '';
        this.state.password = '';
      },

      getPhoneNumber() {
        return '050-3145-8585';
      },

      async onClearClick() {
        const phone = removePhoneHyphen(this.state.phone);
        if (phone == '') {
          this.props.openInfoDialog('電話番号を入力してください。');
          return;
        }
        if (!phone.match(/^\d{11}$/)) {
          this.props.openFailedDialog('不正な電話番号です。');
          return;
        }
        if (!matchPhoneStart(phone)) {
          this.props.openFailedDialog('携帯番号ではない番号が含まれています。');
          return;
        }
        const data = {
          shopId: this.props.shopId,
          phone: phone
        };
        await this.props.clearPassword(data);
        if (0 < this.props.errorMsg.length) {
          this.state.errorMsg = this.props.errorMsg;
        } else {
          this.state.errorMsg = '';
          this.state.isNext = true;
        }
        this.update();
      },

      async onClearNextClick() {
        const phone = removePhoneHyphen(this.state.phone);
        await this.props.clearPasswordNext(phone);
        if (0 < this.props.errorMsg.length) {
          this.state.errorMsg = this.props.errorMsg;
        } else {
          this.state.errorMsg = '';
          this.state.isSet = true;
          this.state.isNext = false;
        }
        this.update();
      },

      onSetClick() {
        const phone = removePhoneHyphen(this.state.phone);
        const data = {
          shopId: this.props.shopId,
          phone: phone,
          password: this.state.password
        };
        this.state.isSet = false;
        this.update();
        this.props.setPassword(data);
      },

      handleChange(target) {
        return e => {
          this.state[target] = e.target.value;
          this.update();
        };
      },

      onChangePage() {
        this.state.isNext = false;
        this.update();
      }
    };
  </script>
  <style type="postcss">
    .password-title {
      font-size: 1.5em;
    }

    .btn {
      margin-top: 16px;
      width: 100%;
    }

    .link-group {
      margin-top: 16px;
    }

    .back-page-txt{
      text-decoration: underline;
      color: blue;
    }

    #error-msg {
      color: red;
      margin: 5px 0;
    }

    @media (max-width: 640px) {
      .password-title {
        margin-bottom: 10px;
        color: #202938;
        font-size: clamp(1.04rem, 5.2vw, 1.235rem);
        font-weight: 700;
        line-height: 1.35;
      }

      .clearPassword,
      .clearPasswordNext {
        width: 100%;
      }

      .clearPassword p,
      .clearPasswordNext p {
        margin: 0 0 6px;
        font-size: 0.7rem;
        line-height: 1.5;
      }

      .clearPasswordNext a[href^="tel:"] {
        display: inline-flex;
        align-items: center;
        min-height: 30px;
        color: #2f62b5;
        font-size: 0.74rem;
        font-weight: 700;
      }

      .btn {
        margin-top: 15px;
      }

      .link-group {
        margin-top: 0;
      }

      #error-msg {
        margin: 6px 0 0;
      }
    }
  </style>
</password>
